var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { renderIcon } from '../../utils';
import { classNames } from '../../utils/style-class.utils';
import Typography from '../typography/typography';
import * as styles from './user-avatar.styles';
export var UserAvatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'lg' : _b, _c = _a.text, text = _c === void 0 ? '' : _c, _d = _a.avatarColor, avatarColor = _d === void 0 ? '' : _d, _e = _a.color, color = _e === void 0 ? undefined : _e, className = _a.className, _f = _a.displayBorder, displayBorder = _f === void 0 ? false : _f, _g = _a.borderColour, borderColour = _g === void 0 ? 'transparent' : _g, isPreschoolImage = _a.isPreschoolImage;
    var textString = text.length > 2 ? text.substring(0, 2) : text;
    var iconSize = styles.getIconSize(size);
    var getAvatarToRender = function () {
        if (isPreschoolImage) {
            return renderIcon('HomeIcon', "h-".concat(iconSize, " w-").concat(iconSize, " text-white"));
        }
        if (textString === '') {
            return renderIcon('UserIcon', "h-".concat(iconSize, " w-").concat(iconSize, " text-white"));
        }
        else {
            return (_jsx(Typography, { type: styles.getTextType(size), color: "white", text: textString }));
        }
    };
    return (_jsx("div", __assign({ style: { backgroundColor: avatarColor }, className: classNames(styles.getAvatarDimensionsBasedOnSizeType(size, displayBorder, borderColour), className, color ? "bg-".concat(color) : '') }, { children: getAvatarToRender() })));
};
export default UserAvatar;
//# sourceMappingURL=user-avatar.js.map